export const userIndexHeaders = [
  {
    text: "User ID",
    value: "id"
  },
  {
    text: "Username",
    value: "username"
  },
  {
    text: "Name",
    value: "first_name" + "last_name"
  },
  {
    text: "Email Address",
    value: "email"
  },
  {
    text: "Actions...",
    sortable: false,
    value: "actions"
  }
];
